import React from 'react'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { Mail, MessageSquare } from 'lucide-react'

const Contact: React.FC = () => {
  const { t } = useTranslation()

  const contactMethods = [
    {
      icon: Mail,
      titleKey: 'contactEmailTitle',
      descKey: 'contactEmailDesc',
      link: 'mailto:support@speedtestry.com',
      linkText: 'support@speedtestry.com'
    },
    {
      icon: MessageSquare,
      titleKey: 'contactFeedbackTitle',
      descKey: 'contactFeedbackDesc',
      link: 'mailto:support@speedtestry.com?subject=SpeedTestry%20Feedback',
      linkText: t('contactFeedbackLink')
    }
  ]

  return (
    <div className="max-w-4xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-3xl md:text-4xl font-bold text-apple-gray-900 mb-6">
          {t('contactTitle')}
        </h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-apple-gray-600 text-lg leading-relaxed mb-10">
            {t('contactIntro')}
          </p>

          <div className="grid md:grid-cols-2 gap-6 mb-10">
            {contactMethods.map((method, index) => (
              <motion.a
                key={method.titleKey}
                href={method.link}
                target={method.link.startsWith('http') ? '_blank' : undefined}
                rel={method.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                className="block bg-apple-gray-50 rounded-2xl p-6 border border-apple-gray-100 hover:border-apple-blue hover:shadow-lg transition-all duration-300"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-apple-blue rounded-xl flex items-center justify-center mr-4">
                    <method.icon className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-apple-gray-900">
                      {t(method.titleKey)}
                    </h3>
                    <p className="text-apple-blue text-sm">
                      {method.linkText}
                    </p>
                  </div>
                </div>
                <p className="text-apple-gray-600 text-sm leading-relaxed">
                  {t(method.descKey)}
                </p>
              </motion.a>
            ))}
          </div>

          <div className="bg-gradient-to-r from-apple-blue to-blue-600 rounded-2xl p-8 text-white">
            <h2 className="text-2xl font-semibold mb-4">
              {t('contactFAQTitle')}
            </h2>
            <p className="text-blue-100 leading-relaxed mb-4">
              {t('contactFAQDesc')}
            </p>
            <ul className="space-y-2 text-blue-100">
              <li>• {t('contactFAQ1')}</li>
              <li>• {t('contactFAQ2')}</li>
              <li>• {t('contactFAQ3')}</li>
            </ul>
          </div>
        </div>
      </motion.div>
    </div>
  )
}

export default Contact



